import { useService } from "../hooks/useService";
import StorageService from "../../services/StorageService";

export function getAdminRolePermissions() {   
  /**
   * @type {StorageService}
   */
  const storage = useService(StorageService);
  const user = storage.get("local::user", {});
  return user?.adminRole?.permissions || [];
}

function findServicePermission(permissions, serviceName) {
  return permissions?.find(
    (permission) => permission.organisationServiceName === serviceName
  );
}

export function isPermissionVisible(permissions, serviceName) {
  const permission = findServicePermission(permissions, serviceName);
  if (!permission) {
    return true;
  }
  return !!permission.isVisible;
}

export function isServiceVisible(serviceName) {
  return isPermissionVisible(getAdminRolePermissions(), serviceName);
}

export function isServiceEditable(serviceName) {
  const permission = findServicePermission(getAdminRolePermissions(), serviceName);
  if (!permission) {
    return true;
  }
  if (!permission.isVisible) {
    return false;
  }
  return !!permission.isEditable;
}

function isOrganisationServiceEnabled(serviceName) {
  const storage = useService(StorageService);
  const servicesSettings = storage.get("system:servicesSettings", {});
  return !!servicesSettings[serviceName];
}

export function canViewService(serviceName) {
  return isOrganisationServiceEnabled(serviceName) && isServiceVisible(serviceName);
}

export function canEditService(serviceName) {
  return isOrganisationServiceEnabled(serviceName) && isServiceEditable(serviceName);
}
